import { createClient } from "@supabase/supabase-js";
import type { Database } from "@shared/database.types";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!SUPABASE_URL || !SUPABASE_KEY) {
  throw new Error(
    "Mancano VITE_SUPABASE_URL e/o VITE_SUPABASE_PUBLISHABLE_KEY nel .env.local"
  );
}

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

// Helper per l'invocazione di edge functions con typing
export async function invokeFunction<TResp = unknown, TBody = unknown>(
  name: string,
  body?: TBody
): Promise<TResp> {
  const { data, error } = await supabase.functions.invoke<TResp>(name, {
    body: body as Record<string, unknown> | undefined,
  });
  if (error) throw error;
  return data as TResp;
}
